// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer {\n\tdisplay: flex;\n\tjustify-content: space-evenly;\n\tpadding: 20px;\n}\n\n.footer-section {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tpadding: 10px;\n}\n\n.footer-section-title {\n\tfont-size: 18px;\n\tfont-weight: bold;\n}\n\n.footer-section-time {\n\tcolor: #83a4ce;\n\tfont-weight: bold;\n}\n\n.footer-section-watch {\n\tcolor: black;\n\tfont-size: 14px;\n}", ""]);
// Exports
module.exports = exports;
